import { IPublicClientApplication } from '@azure/msal-browser';
import { useCallback } from 'react';
import { APP_ROUTES } from 'shared/constants';

import { initialState } from '../store/authSlice';

export default function useLogout(instance: IPublicClientApplication) {
    return useCallback(() => {
        if (instance.getAllAccounts().length === 0) {
            return;
        }

        instance.logout({
            onRedirectNavigate: () => {
                if (initialState.accessToken.token) {
                    window.location.replace(`${ APP_ROUTES.basename }${ APP_ROUTES.candidateOffers }?candidateToken=${ initialState.accessToken.token }`);
                } else {
                    window.location.replace(`${ APP_ROUTES.basename }${ APP_ROUTES.candidateOffers }`);
                }
    
                return false;
            }
        });
    }, [ instance ]);
}
